import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import $ from 'jquery';
import axios from 'axios';

const Cronjob_logs = ({ show, onClose, data }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(10);
    const [total_entries, setTotslEntries] = useState(0);

    // page table data fetch
    const fetchData = () => {
        const params = {
            page,
            per_page: perPage,
            search: searchTerm,
        };
        axios.get(`${baseURL}/cronjob_monitor/logs/${data.sno}`, { params: params })
            .then(response => {
                setData(response.data.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };

    // fetch data & leadstatus
    useEffect(() => {
        if (data) {
            fetchData();
        }
    }, [page, searchTerm, perPage, data]);

    const tableRef = useRef(null);
    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    //   "aaSorting": [],
                    "ordering": false,
                    paging: false,
                    scrollY: "230px", // Set the scroll height here
                    scrollCollapse: true,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":

                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);

    // display func
    function capitalizeFirstLetter(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    return (

        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">{capitalizeFirstLetter(data.cronjob_name)}</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">

                        <div className='col-lg-12 mb-2'>
                            {/* <label className="text-black font-w600 fs-5 mb-3 text-center d-block">{capitalizeFirstLetter(data.cronjob_name)}</label> */}

                            <div className="table-container" >

                                <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd'}}>
                                    <thead>
                                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                            <th className='min-w-80px'>Sno</th>
                                            <th className='min-w-100px'>Start Time</th>
                                            <th className='min-w-100px'>End Time</th>
                                            <th className='min-w-80px'>Duration</th>
                                            <th className='min-w-100px'>Response</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-gray-600 fw-semibold fs-7">
                                        {datas.length === 0 && hasFetched ? (
                                            <tr>
                                                <td colSpan="5" className="text-center text-muted py-2">
                                                    No data available
                                                </td>
                                            </tr>
                                        ) : (
                                            <>
                                                {datas.map((data, index) => (
                                                    <tr key={index}>
                                                        <td className='align-content-center'>
                                                            <label className='text-black font-w400 fs-7'>{index+1}</label>
                                                        </td>
                                                        <td className='align-content-center'>
                                                            <label className='text-black font-w400 fs-7'>{data.formatted_start_time}</label>
                                                        </td>
                                                        <td className='align-content-center'>
                                                            <label className='text-black font-w400 fs-7'>{data.formatted_end_time}</label>
                                                        </td>
                                                        <td className='align-content-center'>
                                                            <label className='text-black font-w400 fs-7'>{data.formatted_duration}</label>
                                                        </td>
                                                        <td>
                                                            <label className='text-black font-w400 fs-7 fw-semibold'><span className='fw-bold'>Processed Records:</span> {data.response? data.response.processed_records : 0}</label><br></br>
                                                            <label className='text-black font-w400 fs-7 fw-semibold'><span className='fw-bold'>Execution Time:</span> {data.response? data.response.execution_time : data.sync_duration}</label>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </>
                                        )}
                                    </tbody>
                                </table>

                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    {/* Bottom left: Showing x to y of z entries */}
                                    <div>
                                        {datas.length > 0 ? (
                                            <span className="text-muted">
                                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                                            </span>
                                        ) : (
                                            <span className="text-muted">
                                                Showing 0 to 0 of 0 entries
                                            </span>
                                        )}
                                    </div>

                                    {/* Bottom right: Pagination */}
                                    <nav>
                                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                            {/* Previous Button */}
                                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                                    Previous
                                                </button>
                                            </li>

                                            {/* First Page */}
                                            <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                                    1
                                                </button>
                                            </li>

                                            {/* Left Ellipsis */}
                                            {page > 4 && (
                                                <li className="page-item disabled">
                                                    <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                </li>
                                            )}

                                            {/* Pages Around Current */}
                                            {Array.from({ length: totalPages }, (_, i) => i + 1)
                                                .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                                .map(p => (
                                                    <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                            {p}
                                                        </button>
                                                    </li>
                                                ))}

                                            {/* Right Ellipsis */}
                                            {page < totalPages - 3 && (
                                                <li className="page-item disabled">
                                                    <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                                </li>
                                            )}

                                            {/* Last Page */}
                                            {totalPages > 1 && (
                                                <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                                        {totalPages}
                                                    </button>
                                                </li>
                                            )}

                                            {/* Next Button */}
                                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                                    Next
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>

                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Cronjob_logs;
